import { useState, useEffect } from "react";
import {
  getSummary,
  type AccountantStatusSummary,
} from "../../services/accountantStatus";

export function useAccountantStatusSummary(year: number, month: number) {
  const [summary, setSummary] = useState<AccountantStatusSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getSummary({ year, month });
        if (!cancelled) {
          setSummary(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(
            err instanceof Error ? err.message : "Failed to load summary"
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [year, month]);

  return { summary, loading, error };
}
